export default {
  styleOverrides: {
    h5: {
      fontWeight: 300,
    },
    h6: {
      fontWeight: 300,
    },
  },
};
